export class LeaveProject {
  public static readonly type = '[Project/Users/leave] LeaveProject';

  constructor(public userId: string) {}
}
